import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: ${Styles.zIndex.max};
  background-color: ${Styles.color.alert.info.background};
  color: ${Styles.color.contrastBackground};
  font-family: ${Styles.fontFamily.brand};
  font-size: 0.75rem;
  font-weight: ${Styles.fontWeight.normal};
  height: 1.5rem;
  padding: 0.375rem;
  line-height: 1;
  border-radius: 0 0 0.3125rem 0;
`;
